import styled, { CSSProperties } from 'styled-components';

import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';
import { abbreviate } from '@utils/strings';

import { Avatar, AvatarProps } from './avatar';

export type AvatarTagProps = Pick<AvatarProps, 'name' | 'src'> & {
  style?: CSSProperties;
};

export const AvatarTag = ({ style, ...rest }: AvatarTagProps) => {
  const abbreviatedName = abbreviate(rest.name);

  return (
    <Container style={style}>
      <Avatar {...rest} />
      <Text font="semibold14" text={abbreviatedName} />
    </Container>
  );
};

const Container = styled(Stack).attrs({
  orientation: 'horizontal',
  align: 'center',
  space: 1,
})({
  backgroundColor: theme.color.uiTrans5,
  padding: pxToRem(4),
  borderRadius: pxToRem(6),
  width: pxToRem(72),
});
